export enum SortOrderType {
  LAST_ACCESS_AT_DESC = "last_access_at_desc",
  UPDATED_AT_DESC = "updated_at_desc",
  REGISTER_AT_DESC = "register_at_desc",
  ACTIVITY_COUNT_DESC = "activity_count_desc"
}
export enum NumberOfDisplaysType {
  NUMBER_OF_DISPLAYS_20 = 20,
  NUMBER_OF_DISPLAYS_50 = 50,
  NUMBER_OF_DISPLAYS_100 = 100
}

export enum DisplayMode {
  CARD = "card",
  LIST = "list"
}
